import { useEffect, useCallback, useState } from 'react';
import { useRouter } from 'next/router';

const useUtmParameters = () => {
  const router = useRouter();
  const [utmInitialized, setUtmInitialized] = useState(false);

  const paramsToCheck = ['utm_source', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_term'];

  const setLocalStorageIfParamExists = useCallback(() => {
    let found = false;

    paramsToCheck.forEach((key) => {
      const value = router.query[key];
      if (value) {
        localStorage.setItem(key, String(value));
        found = true;
      }
    });

    if (found) {
      const utmTags = paramsToCheck
        .map((key, index) => {
          const value = localStorage.getItem(key);
          if (!value) return '';
          
          return `${index === 0 ? '?' : '&'}${key}=${value}`;
        })
        .filter(Boolean)
        .join('');

      localStorage.setItem('utmTags', utmTags);

      // Удаляем UTM из URL
      const cleanedQuery = { ...router.query };
      paramsToCheck.forEach((key) => delete cleanedQuery[key]);

      router.replace(
        {
          pathname: router.pathname,
          query: cleanedQuery,
        },
        undefined,
        { shallow: true },
      );
    }

    setUtmInitialized(true);
  }, [router]);

  useEffect(() => {
    if (!utmInitialized) {
      setLocalStorageIfParamExists();
    }
  }, [setLocalStorageIfParamExists, utmInitialized]);

  return null;
};

export default useUtmParameters;
